import alwaysSame from 'utils/functions/nullary/alwaysSame.util';

import {
  feConsultationFormCreate,
  feConsultationFormDelete,
  feConsultationFormDuplicate,
  feConsultationFormsFetchSuccess,
  feConsultationFormToggleStatus,
  feConsultationFormUpdate,
} from './consultationForms.action';

const initState = () => ({
  forms: [],
  isFetching: false,
});

const reduceFetchSuccess = (state, action) => ({
  ...state,
  forms: action?.data,
  isFetching: false,
});

const reduceCreate = (state, action) => ({
  ...state,
  forms: [...state.forms, action?.data],
});

const reduceUpdate = (state, action) => ({
  ...state,
  forms: state.forms.map((f) => (f.id === action?.data?.id ? { ...f, ...action?.data } : f)),
});

const reduceDelete = (state, action) => ({
  ...state,
  forms: state.forms.filter((f) => f.id !== action?.data),
});

const reduceToggleStatus = (state, action) => ({
  ...state,
  forms: state.forms.map((f) => (f.id === action?.data?.formId ? { ...f, status: action?.data?.newStatus } : f)),
});

const reduceDuplicate = (state, action) => ({
  ...state,
  forms: [...state.forms, action?.data],
});

const MAP = {
  [feConsultationFormsFetchSuccess.AT.name]: reduceFetchSuccess,
  [feConsultationFormCreate.AT.name]: reduceCreate,
  [feConsultationFormUpdate.AT.name]: reduceUpdate,
  [feConsultationFormDelete.AT.name]: reduceDelete,
  [feConsultationFormToggleStatus.AT.name]: reduceToggleStatus,
  [feConsultationFormDuplicate.AT.name]: reduceDuplicate,
};

const consultationFormsReducer = (state, action) => (MAP[action?.type] ?? alwaysSame)(state ?? initState(), action ?? {});

export default consultationFormsReducer;
